module.exports = __webpack_public_path__ + "static/img/13.eceb4c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/eng/13.png
// module id = RMR/
// module chunks = 0